import { z } from "zod";
import { pageOf, pageQuerySchema } from "../common/pagination.js";
import { patchOf } from "../common/patch.js";
import { localDateSchema, timestampSchema, uuidSchema } from "../common/primitives.js";
import { stationLicenseStateSchema, stationLicenseTypeSchema } from "./enums.js";
/**
 * İstasyon satış belgeleri — tütün / alkol (Prompt 16 aşama B, ADR 0016 §18, mevzuat sorusu #62). v1'de satışı
 * ENGELLEMEZ; bitişe `licenseWarningDays` kala `market.license.expiring`, süresi geçince `market.license.expired`
 * olayı (worker günlük işi, belge × bitiş tarihi başına bir kez). Belge dosyası depolama akışıyla yüklenir
 * (`purpose: DOCUMENT`) ve burada yalnızca `fileId` bağlanır.
 */
export const stationLicenseSchema = z.object({
    id: uuidSchema,
    companyId: uuidSchema,
    stationId: uuidSchema,
    stationName: z.string(),
    licenseType: stationLicenseTypeSchema,
    documentNo: z.string(),
    issuer: z.string().nullable(),
    issuedOn: localDateSchema.nullable(),
    validFrom: localDateSchema,
    validUntil: localDateSchema.nullable().describe("Boş = süresiz"),
    fileId: uuidSchema.nullable(),
    fileName: z.string().nullable(),
    note: z.string().nullable(),
    isActive: z.boolean(),
    state: stationLicenseStateSchema,
    daysToExpiry: z.number().int().nullable(),
    expiryAlertSentFor: localDateSchema.nullable(),
    createdBy: uuidSchema.nullable(),
    createdAt: timestampSchema,
    version: z.number().int(),
});
export const stationLicensePageSchema = pageOf(stationLicenseSchema);
export const listStationLicensesQuerySchema = pageQuerySchema.extend({
    companyId: uuidSchema,
    stationId: uuidSchema.optional(),
    licenseType: stationLicenseTypeSchema.optional(),
    state: stationLicenseStateSchema.optional(),
    includeInactive: z.enum(["true", "false"]).optional(),
});
const licenseFields = z.object({
    licenseType: stationLicenseTypeSchema,
    documentNo: z.string().trim().min(1).max(60),
    issuer: z.string().trim().max(200).nullable().default(null),
    issuedOn: localDateSchema.nullable().default(null),
    validFrom: localDateSchema,
    validUntil: localDateSchema.nullable().default(null),
    fileId: uuidSchema.nullable().default(null).describe("Depolama akışıyla yüklenmiş belge (DOCUMENT)"),
    note: z.string().trim().max(1000).nullable().default(null),
});
export const createStationLicenseSchema = licenseFields
    .extend({ stationId: uuidSchema })
    .refine((value) => value.validUntil === null || value.validUntil >= value.validFrom, {
    path: ["validUntil"],
    message: "Bitiş, başlangıçtan önce olamaz",
});
export const updateStationLicenseSchema = patchOf(licenseFields).extend({
    isActive: z.boolean().optional(),
    version: z.number().int().positive(),
});
//# sourceMappingURL=licenses.js.map